import { ReactNode } from "react";
import {
  useForm,
  FormProvider,
  SubmitHandler,
  FieldValues,
} from "react-hook-form";

interface FormCustomProps {
  children: (methods: ReturnType<typeof useForm>) => ReactNode;
  onSubmitHandle: SubmitHandler<FieldValues>;
}

const FormCustom = ({ children, onSubmitHandle }: FormCustomProps) => {
  const methods = useForm({
    mode: "onBlur",
  });
  const { handleSubmit, reset } = methods;

  const onSubmit: SubmitHandler<FieldValues> = async (data) => {
    try {
      await onSubmitHandle(data);
      reset();
    } catch (error) {
      throw error;
    }
  };

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col items-start w-[100%] md:gap-4 mx-auto"
      >
        {children(methods)}
      </form>
    </FormProvider>
  );
};

export default FormCustom;
